<script setup lang="ts">
import { ref, inject, onMounted, reactive } from 'vue';
import { useLocaleStore } from '@/stores/locale';
import { useI18n } from 'vue-i18n';
import axiosApiClient from '@/axios';
import { useUserStore } from '@/stores/user';

const localeStore = useLocaleStore();
const t = useI18n().t;
const swal = inject('$swal') as any;
const userStore = useUserStore();
//Calculator
const estCalc = reactive({
    real_estate_type: 'villa',
    project_type: 'bones',
});


const tank = reactive({
    space: 0,
    qty: 0,
    ratio: 0,
    total_space: 0,
    price: 460,
    total_amount: 0,
    notes: 'tank_hint',
});
const bayyarah = reactive({
    space: 0,
    qty: 0,
    ratio: 0,
    total_space: 0,
    price: 460,
    total_amount: 0,
    notes: 'bayyarah_hint',
});
const soor = reactive({
    space: 0,
    qty: 0,
    ratio: 0,
    total_space: 0,
    price: 460,
    total_amount: 0,
    notes: 'soor_hint',
});
const sitrah = reactive({
    space: 0,
    qty: 0,
    ratio: 0,
    total_space: 0,
    price: 460,
    total_amount: 0,
    notes: 'sitrah_hint',
});
const land_floor = reactive({
    space: 0,
    qty: 0,
    ratio: 0,
    total_space: 0,
    price: 460,
    total_amount: 0,
    notes: 'land_floor_hint',
});
const recur_floor = reactive({
    space: 0,
    qty: 0,
    ratio: 0,
    total_space: 0,
    price: 460,
    total_amount: 0,
    notes: 'recur_floor_hint',
});
const relative_floor = reactive({
    space: 0,
    qty: 0,
    ratio: 0,
    total_space: 0,
    price: 460,
    total_amount: 0,
    notes: 'relative_floor_hint',
});
const stair_box = reactive({
    space: 0,
    qty: 0,
    ratio: 0,
    total_space: 0,
    price: 460,
    total_amount: 0,
    notes: 'stair_box_hint',
});

const ratioCalculation = async () => {
    if (estCalc.real_estate_type == 'villa' && estCalc.project_type == 'bones') {
        tank.ratio = 1.5;
        bayyarah.ratio = 1;
        soor.ratio = 2;
        sitrah.ratio = 0.5;
        land_floor.ratio = 1;
        recur_floor.ratio = 1;
        relative_floor.ratio = 1;
        stair_box.ratio = 1;

        tank.price = 460;
        bayyarah.price = 460;
        soor.price = 460;
        sitrah.price = 460;
        land_floor.price = 460;
        recur_floor.price = 460;
        relative_floor.price = 460;
        stair_box.price = 460;

    } else if (estCalc.real_estate_type == 'building' && estCalc.project_type == 'bones') {
        tank.ratio = 1.5;
        bayyarah.ratio = 1;
        soor.ratio = 2;
        sitrah.ratio = 0.5;
        land_floor.ratio = 1;
        recur_floor.ratio = 1;
        relative_floor.ratio = 1;
        stair_box.ratio = 1;

        tank.price = 440;
        bayyarah.price = 440;
        soor.price = 440;
        sitrah.price = 440;
        land_floor.price = 440;
        recur_floor.price = 440;
        relative_floor.price = 440;
        stair_box.price = 440;
    } else if (estCalc.real_estate_type == 'villa' && estCalc.project_type == 'bones_and_finishing') {
        tank.ratio = 1.25;
        bayyarah.ratio = 1;
        soor.ratio = 1.5;
        sitrah.ratio = 0.5;
        land_floor.ratio = 1;
        recur_floor.ratio = 1;
        relative_floor.ratio = 1;
        stair_box.ratio = 1;

        tank.price = 1250;
        bayyarah.price = 1250;
        soor.price = 1250;
        sitrah.price = 1250;
        land_floor.price = 1250;
        recur_floor.price = 1250;
        relative_floor.price = 1250;
        stair_box.price = 1250;
    } else if (estCalc.real_estate_type == 'building' && estCalc.project_type == 'bones_and_finishing') {
        tank.ratio = 1.25;
        bayyarah.ratio = 1;
        soor.ratio = 1.5;
        sitrah.ratio = 0.5;
        land_floor.ratio = 1;
        recur_floor.ratio = 1;
        relative_floor.ratio = 1;
        stair_box.ratio = 1;

        tank.price = 1150;
        bayyarah.price = 1150;
        soor.price = 1150;
        sitrah.price = 1150;
        land_floor.price = 1150;
        recur_floor.price = 1150;
        relative_floor.price = 1150;
        stair_box.price = 1150;
    }
    else {
        tank.ratio = 1;
        bayyarah.ratio = 1;
        soor.ratio = 1;
        sitrah.ratio = 1;
        land_floor.ratio = 1;
        recur_floor.ratio = 1;
        relative_floor.ratio = 1;
        stair_box.ratio = 1;
    }
};

const calculateTank = () => {
    tank.total_space = tank.space * tank.qty;
    tank.total_space = tank.total_space * tank.ratio;
    tank.total_amount = tank.total_space * tank.price;
};
const calculateBayyarah = () => {
    bayyarah.total_space = bayyarah.space * bayyarah.qty;
    bayyarah.total_space = bayyarah.total_space * bayyarah.ratio;
    bayyarah.total_amount = bayyarah.total_space * bayyarah.price;
};
const calculateSoor = () => {
    soor.total_space = soor.space * soor.qty;
    soor.total_space = soor.total_space * soor.ratio;
    soor.total_amount = soor.total_space * soor.price;
};
const calculateSitrah = () => {
    sitrah.total_space = sitrah.space * sitrah.qty;
    sitrah.total_space = sitrah.total_space * sitrah.ratio;
    sitrah.total_amount = sitrah.total_space * sitrah.price;
};
const calculateLandFloor = () => {
    land_floor.total_space = land_floor.space * land_floor.qty;
    land_floor.total_space = land_floor.total_space * land_floor.ratio;
    land_floor.total_amount = land_floor.total_space * land_floor.price;
};
const calculateRecurFloor = () => {
    recur_floor.total_space = recur_floor.space * recur_floor.qty;
    recur_floor.total_space = recur_floor.total_space * recur_floor.ratio;
    recur_floor.total_amount = recur_floor.total_space * recur_floor.price;
};
const calculateRelativeFloor = () => {
    relative_floor.total_space = relative_floor.space * relative_floor.qty;
    relative_floor.total_space = relative_floor.total_space * relative_floor.ratio;
    relative_floor.total_amount = relative_floor.total_space * relative_floor.price;
};
const calculateStairBox = () => {
    stair_box.total_space = stair_box.space * stair_box.qty;
    stair_box.total_space = stair_box.total_space * stair_box.ratio;
    stair_box.total_amount = stair_box.total_space * stair_box.price;
};
const calculate = () => {
    ratioCalculation();
    calculateTank();
    calculateBayyarah();
    calculateSoor();
    calculateSitrah();
    calculateLandFloor();
    calculateRecurFloor();
    calculateRelativeFloor();
    calculateStairBox();
    buildCalculatorCart();
};
const calculateTotal = () => {
    const total = tank.total_amount + bayyarah.total_amount + soor.total_amount + sitrah.total_amount +
        land_floor.total_amount + recur_floor.total_amount + relative_floor.total_amount + stair_box.total_amount;
    return total;
};
const corp_info = ref({
    name: '',
    address: '',
    phone: '',
    mobile: '',
    email: '',
    description: '',
    logo: '',
});
const fetchGeneralConfigs = async () => {
    try {
        //const response = await axiosApiClient.get('/api/configurations/corp/info');
        //configurations.value = response.data;
        //from localStorage
        corp_info.value = localStorage.getItem('corp') ? JSON.parse(localStorage.getItem('corp') || '') : {
            name: '',
            address: '',
            phone: '',
            mobile: '',
            email: '',
            description: '',
            logo: '',
        };
    } catch (error) {
        console.error('Error fetching configurations:', error);
    }
};
onMounted(() => {
    fetchGeneralConfigs();
    readCalculatorCart();
    calculate();
});
const readCalculatorCart = async () => {
    //sync with cart in localStorage
    const cart = JSON.parse(localStorage.getItem('calculatorCart') || '[]');
    if (cart.length > 0) {
        for (let i = 0; i < cart.length; i++) {
            const item = cart[i];
            if (item.type == 'tank') {
                tank.qty = item.qty;
                tank.space = item.space;
            } else if (item.type == 'bayyarah') {
                bayyarah.qty = item.qty;
                bayyarah.space = item.space;
            } else if (item.type == 'soor') {
                soor.qty = item.qty;
                soor.space = item.space;
            } else if (item.type == 'sitrah') {
                sitrah.qty = item.qty;
                sitrah.space = item.space;
            } else if (item.type == 'land_floor') {
                land_floor.qty = item.qty;
                land_floor.space = item.space;
            } else if (item.type == 'recur_floor') {
                recur_floor.qty = item.qty;
                recur_floor.space = item.space;
            } else if (item.type == 'relative_floor') {
                relative_floor.qty = item.qty;
                relative_floor.space = item.space;
            } else if (item.type == 'stair_box') {
                stair_box.qty = item.qty;
                stair_box.space = item.space;
            }
        }
    }
};
const buildCalculatorCart = () => {
    const cart = [];
    cart.push({
        type: 'tank',
        qty: tank.qty,
        space: tank.space,
    });
    cart.push({
        type: 'bayyarah',
        qty: bayyarah.qty,
        space: bayyarah.space,
    });
    cart.push({
        type: 'soor',
        qty: soor.qty,
        space: soor.space,
    });
    cart.push({
        type: 'sitrah',
        qty: sitrah.qty,
        space: sitrah.space,
    });
    cart.push({
        type: 'land_floor',
        qty: land_floor.qty,
        space: land_floor.space,
    });
    cart.push({
        type: 'recur_floor',
        qty: recur_floor.qty,
        space: recur_floor.space,
    });
    cart.push({
        type: 'relative_floor',
        qty: relative_floor.qty,
        space: relative_floor.space,
    });
    cart.push({
        type: 'stair_box',
        qty: stair_box.qty,
        space: stair_box.space,
    });
    localStorage.setItem('calculatorCart', JSON.stringify(cart));
};

const print = async () => {
    //user should have account in ssytem
    let user_info = await userStore.getUser();
    if (user_info == null || user_info == undefined || user_info.id == null || user_info.id == undefined) {
        //show error message
        swal.fire({
            icon: 'error',
            title: t('Error'),
            text: t('Please login to print the estimation!'),
            showCancelButton: true,
            confirmButtonText: t('Login'),
            cancelButtonText: t('Cancel'),
        }).then((result: any) => {
            if (result.isConfirmed) {
                window.location.href = '/login';
            }
        });
        return;
    }

    if (calculateTotal() == 0) {
        swal.fire({
            icon: 'error',
            title: t('Error'),
            text: t('Please fill in the required fields!'),
        });
        return;
    }
    //confirmation before print
    const result = await swal.fire({
        icon: 'warning',
        title: t('Are you sure?'),
        text: t('Do you want to print the estimation?'),
        showCancelButton: true,
        confirmButtonText: t('Yes'),
        cancelButtonText: t('No'),
    });
    if (!result.isConfirmed) {
        return;
    }
    saveClientRequest(user_info).then(() => {
        //after saving request, print the estimation

        clearCalculator();
    }).catch((error) => {
        console.error('Error saving request:', error);
        swal.fire({
            icon: 'error',
            title: t('Error'),
            text: t('Something went wrong. Please try again!'),
        });
    });
};
const saveClientRequest = async (user_info:any) => {
    //save to database

    const components = {
        tank: {
            qty: tank.qty,
            space: tank.space,
            total_space: tank.total_space,
            total_amount: tank.total_amount,
            ratio: tank.ratio,
            price: tank.price,
            notes: tank.notes,
        },
        bayyarah: {
            qty: bayyarah.qty,
            space: bayyarah.space,
            total_space: bayyarah.total_space,
            total_amount: bayyarah.total_amount,
            ratio: bayyarah.ratio,
            price: bayyarah.price,
            notes: bayyarah.notes,
        },
        soor: {
            qty: soor.qty,
            space: soor.space,
            total_space: soor.total_space,
            total_amount: soor.total_amount,
            ratio: soor.ratio,
            price: soor.price,
            notes: soor.notes,
        },
        sitrah: {
            qty: sitrah.qty,
            space: sitrah.space,
            total_space: sitrah.total_space,
            total_amount: sitrah.total_amount,
            ratio: sitrah.ratio,
            price: sitrah.price,
            notes: sitrah.notes,
        },
        land_floor: {
            qty: land_floor.qty,
            space: land_floor.space,
            total_space: land_floor.total_space,
            total_amount: land_floor.total_amount,
            ratio: land_floor.ratio,
            price: land_floor.price,
            notes: land_floor.notes,
        },
        recur_floor: {
            qty: recur_floor.qty,
            space: recur_floor.space,
            total_space: recur_floor.total_space,
            total_amount: recur_floor.total_amount,
            ratio: recur_floor.ratio,
            price: recur_floor.price,
            notes: recur_floor.notes,
        },
        relative_floor: {
            qty: relative_floor.qty,
            space: relative_floor.space,
            total_space: relative_floor.total_space,
            total_amount: relative_floor.total_amount,
            ratio: relative_floor.ratio,
            price: relative_floor.price,
            notes: relative_floor.notes,
        },
        stair_box: {
            qty: stair_box.qty,
            space: stair_box.space,
            total_space: stair_box.total_space,
            total_amount: stair_box.total_amount,
            ratio: stair_box.ratio,
            price: stair_box.price,
            notes: stair_box.notes,
        },
    };
    let payload = {
        name: user_info.name,
        email: user_info.email,
        phone: user_info.mobile,
        city: user_info.city,
        realty_type: estCalc.real_estate_type,
        project_type: estCalc.project_type,
        description: JSON.stringify(components),
    }
    try {
        const response = await axiosApiClient.post('/api/estimation/save', payload);
        if (response.data.status == 'success') {
            printEstimation();
        } else {
            swal.fire({
                icon: 'error',
                title: t('Error'),
                text: t('Something went wrong. Please try again!'),
            });
        }
    } catch (error) {
        console.error('Error saving request:', error);
        swal.fire({
            icon: 'error',
            title: t('Error'),
            text: t('Something went wrong. Please try again!'),
        });
    };
};
const printEstimation = () => {
    const printWindow = window.open('', '_blank') || window;
    var corp_name = corp_info.value.name;
    var logo = corp_info.value.logo;
    printWindow.document.write(`<html><head><title>${t('Print Estimation')}</title></head><body dir='${localeStore.locale == 'ar' ? 'rtl' : 'ltr'}'>`);
    printWindow.document.write(`<div style="width: 100%;text-align: center"><h1>${corp_name}</h1></div>`);
    printWindow.document.write(`<div style="width: 100%;text-align: center"><img src="${logo}" alt="Logo" style="width: 200px;height: 100px;"/></div>`);
    printWindow.document.write(`<div style="width: 100%;text-align: center"><h1>${t('Estimation')}</h1></div>`);
    printWindow.document.write(`<p>${t('Real Estate Type')}: ${t(estCalc.real_estate_type)} </p>`);
    printWindow.document.write(`<p>${t('Project Type')}: ${t(estCalc.project_type)} </p>`);
    printWindow.document.write(`<h2>${t('Tank')}</h2>`);
    printWindow.document.write(`<p>${t('Total Space')}: ${t(tank.total_space)} </p>`);
    printWindow.document.write(`<p>${t('Total Amount')}: ${tank.total_amount} </p>`);
    // Add other components here
    printWindow.document.write(`<h2>${t('Bayyarah')}</h2>`);
    printWindow.document.write(`<p>${t('Total Space')}: ${t(bayyarah.total_space)} </p>`);
    printWindow.document.write(`<p>${t('Total Amount')}: ${bayyarah.total_amount} </p>`);
    printWindow.document.write(`<h2>${t('Soor')}</h2>`);
    printWindow.document.write(`<p>${t('Total Space')}: ${t(soor.total_space)} </p>`);
    printWindow.document.write(`<p>${t('Total Amount')}: ${soor.total_amount} </p>`);
    printWindow.document.write(`<h2>${t('Sitrah')}</h2>`);
    printWindow.document.write(`<p>${t('Total Space')}: ${t(sitrah.total_space)} </p>`);
    printWindow.document.write(`<p>${t('Total Amount')}: ${sitrah.total_amount} </p>`);
    printWindow.document.write(`<h2>${t('Land Floor')}</h2>`);
    printWindow.document.write(`<p>${t('Total Space')}: ${t(land_floor.total_space)} </p>`);
    printWindow.document.write(`<p>${t('Total Amount')}: ${land_floor.total_amount} </p>`);
    printWindow.document.write(`<h2>${t('Recur Floor')}</h2>`);
    printWindow.document.write(`<p>${t('Total Space')}: ${t(recur_floor.total_space)} </p>`);
    printWindow.document.write(`<p>${t('Total Amount')}: ${recur_floor.total_amount} </p>`);
    printWindow.document.write(`<h2>${t('Relative Floor')}</h2>`);
    printWindow.document.write(`<p>${t('Total Space')}: ${t(relative_floor.total_space)} </p>`);
    printWindow.document.write(`<p>${t('Total Amount')}: ${relative_floor.total_amount} </p>`);
    printWindow.document.write(`<h2>${t('Stair Box')}</h2>`);
    printWindow.document.write(`<p>${t('Total Space')}: ${t(stair_box.total_space)} </p>`);
    printWindow.document.write(`<p>${t('Total Amount')}: ${stair_box.total_amount} </p>`);
    printWindow.document.write(`<h2>${t('Total Amount')}</h2>`);
    printWindow.document.write(`<p>${t('Total Amount')}: ${calculateTotal()} </p>`);
    printWindow.document.write(`</body></html>`);
    printWindow.document.close();
    printWindow.print();
};
const clearCalculator = () => {
    tank.qty = 0;
    tank.space = 0;
    bayyarah.qty = 0;
    bayyarah.space = 0;
    soor.qty = 0;
    soor.space = 0;
    sitrah.qty = 0;
    sitrah.space = 0;
    land_floor.qty = 0;
    land_floor.space = 0;
    recur_floor.qty = 0;
    recur_floor.space = 0;
    relative_floor.qty = 0;
    relative_floor.space = 0;
    stair_box.qty = 0;
    stair_box.space = 0;
    estCalc.real_estate_type = 'villa';
    estCalc.project_type = 'bones';
    localStorage.removeItem('calculatorCart');
    calculate();
};
</script>
<template>
    <div class="row" :dir="localeStore.locale == 'ar' ? 'rtl' : 'ltr'">
        <div class="col-lg-3"></div>
        <div class="col-lg-6">
            <div class="calculator">
                <div class="calculator-form">
                    <div class="row">
                        <!--calculator options-->
                        <div class="flex flex-wrap gap-3">
                            <div class="md:min-w-32">
                                <label for="">{{ t('Real Estate Type') }}</label>
                                <div class="flex flex-row h-10 p-1 border rounded-md justify-center gap-4">
                                    <div>
                                        <input type="radio" name="real_estate_type" id="villa" value="villa"
                                            class="peer hidden" :checked="estCalc.real_estate_type == 'villa'"
                                            v-model="estCalc.real_estate_type" @change="calculate" />
                                        <label for="villa"
                                            class="block cursor-pointer select-none rounded-xl p-1 px-4 text-center peer-checked:bg-blue-700 peer-checked:font-bold peer-checked:text-white">
                                            {{ t('Villas') }}
                                        </label>
                                    </div>

                                    <div>
                                        <input type="radio" name="real_estate_type" id="building" value="building"
                                            class="peer hidden" :checked="estCalc.real_estate_type == 'building'"
                                            v-model="estCalc.real_estate_type" @change="calculate" />
                                        <label for="building"
                                            class="block cursor-pointer select-none rounded-xl p-1 px-4 text-center peer-checked:bg-blue-700 peer-checked:font-bold peer-checked:text-white">
                                            {{ t('Building') }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="md:min-w-32">
                                <label for="">{{ t('Project Type') }}</label>
                                <div class="flex h-10 p-1 border rounded-md justify-center gap-4">
                                    <div>
                                        <input type="radio" name="project_type" id="project_type_bones" value="bones"
                                            class="peer hidden" :checked="estCalc.project_type == 'bones'
                                                " v-model="estCalc.project_type" @change="calculate" />
                                        <label for="project_type_bones"
                                            class="block cursor-pointer select-none rounded-xl p-1 px-4 text-center peer-checked:bg-blue-700 peer-checked:font-bold peer-checked:text-white">
                                            {{ t('project_type_bones') }}
                                        </label>
                                    </div>
                                    <!-- <div>
                                        <input type="radio" name="project_type" id="project_type_finishing"
                                            value="finishing" class="peer hidden" :checked="estCalc.project_type == 'finishing'
                                                " v-model="estCalc.project_type" @change="calculate" />
                                        <label for="project_type_finishing"
                                            class="block cursor-pointer select-none rounded-xl p-1 text-center peer-checked:bg-blue-500 peer-checked:font-bold peer-checked:text-white">
                                            {{ t('project_type_finishing') }}
                                        </label>
                                    </div> -->
                                    <div>
                                        <input type="radio" name="project_type" id="project_type_bones_and_finishing"
                                            value="bones_and_finishing" class="peer hidden" :checked="estCalc.project_type == 'bones_and_finishing'
                                                " v-model="estCalc.project_type" @change="calculate" />
                                        <label for="project_type_bones_and_finishing"
                                            class="block cursor-pointer select-none rounded-xl p-1 px-4 text-center peer-checked:bg-blue-700 peer-checked:font-bold peer-checked:text-white">
                                            {{ t('project_type_bones_and_finishing') }}
                                        </label>
                                    </div>
                                    <!-- <div>
                                        <input type="radio" name="project_type" id="project_type_key_delivery"
                                            value="key_delivery" class="peer hidden" :checked="estCalc.project_type == 'key_delivery'
                                                " v-model="estCalc.project_type" @change="calculate" />
                                        <label for="project_type_key_delivery"
                                            class="block cursor-pointer select-none rounded-xl p-1 text-center peer-checked:bg-blue-500 peer-checked:font-bold peer-checked:text-white">
                                            {{ t('project_type_key_delivery') }}
                                        </label>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                        <!--calc components-->
                        <div class="flex flex-col p-3 border my-3">
                            <!--1:tank-->
                            <div class="flex gap-2 justify-between">
                                <div class="flex flex-col w-50">
                                    <label for="tank_notes">{{ t('Tank') }}</label>
                                    <small aria-label="tank_notes">{{ t(tank.notes) }}</small>
                                </div>
                                <div class="w-20">
                                    <label for="tank_qty">{{ t('Calculator.Qty') }}</label>
                                    <input id="tank_qty" type="number" value="0" class="form-control" v-model="tank.qty"
                                        @change="calculate" min="0" max="9999" />
                                </div>
                                <div class="w-20">
                                    <label for="tank_space">{{ t('Space') }}</label>
                                    <input id="tank_space" type="number" value="0" class="form-control"
                                        v-model="tank.space" @change="calculate" min="0" max="9999" />
                                </div>
                                <div class="w-20">
                                    <!--Total tank-->
                                    <label for="tank_total_amount">{{ t('Total') }}</label>
                                    <label aria-label="tank_total_amount" class="form-control"
                                        v-html="tank.total_amount" />
                                </div>
                            </div>
                            <!--2:bayyarah-->
                            <div class="flex gap-2 justify-between">
                                <div class="flex flex-col w-50">
                                    <label for="bayyarah_notes">{{ t('Bayyarah') }}</label>
                                    <small aria-label="bayyarah_notes">{{ t(bayyarah.notes) }}</small>
                                </div>
                                <div class="w-20">
                                    <label for="bayyarah_qty">{{ t('Calculator.Qty') }}</label>
                                    <input id="bayyarah_qty" type="number" value="0" class="form-control"
                                        v-model="bayyarah.qty" min="0" max="9999" @change="calculate" />
                                </div>
                                <div class="w-20">
                                    <label for="bayyarah_space">{{ t('Space') }}</label>
                                    <input id="bayyarah_space" type="number" value="0" class="form-control"
                                        v-model="bayyarah.space" min="0" max="9999" @change="calculate" />
                                </div>
                                <div class="w-20">
                                    <!--Total bayyarah-->
                                    <label for="bayyarah_total_amount">{{ t('Total') }}</label>
                                    <label aria-label="bayyarah_total_amount" class="form-control"
                                        v-html="bayyarah.total_amount" />
                                </div>
                            </div>
                            <!--3:soor-->
                            <div class="flex gap-2 justify-between">
                                <div class="flex flex-col w-50">
                                    <label for="soor_notes">{{ t('Soor') }}</label>
                                    <small aria-label="soor_notes">{{ t(soor.notes) }}</small>
                                </div>
                                <div class="w-20">
                                    <label for="soor_qty">{{ t('Calculator.Qty') }}</label>
                                    <input id="soor_qty" type="number" value="0" class="form-control" v-model="soor.qty"
                                        min="0" max="9999" @change="calculate" />
                                </div>
                                <div class="w-20">
                                    <label for="soor_space">{{ t('Space') }}</label>
                                    <input id="soor_space" type="number" value="0" class="form-control"
                                        v-model="soor.space" min="0" max="9999" @change="calculate" />
                                </div>
                                <div class="w-20">
                                    <!--Total soor-->
                                    <label for="soor_total_amount">{{ t('Total') }}</label>
                                    <label aria-label="soor_total_amount" class="form-control"
                                        v-html="soor.total_amount" />
                                </div>
                            </div>
                            <!--4:sitrah-->
                            <div class="flex gap-2 justify-between">
                                <div class="flex flex-col w-50">
                                    <label for="sitrah_notes">{{ t('Sitrah') }}</label>
                                    <small aria-label="sitrah_notes">{{ t(sitrah.notes) }}</small>
                                </div>
                                <div class="w-20">
                                    <label for="sitrah_qty">{{ t('Calculator.Qty') }}</label>
                                    <input id="sitrah_qty" type="number" value="0" class="form-control"
                                        v-model="sitrah.qty" min="0" max="9999" @change="calculate" />
                                </div>
                                <div class="w-20">
                                    <label for="sitrah_space">{{ t('Space') }}</label>
                                    <input id="sitrah_space" type="number" value="0" class="form-control"
                                        v-model="sitrah.space" min="0" max="9999" @change="calculate" />
                                </div>
                                <div class="w-20">
                                    <!--Total sitrah-->
                                    <label for="sitrah_total_amount">{{ t('Total') }}</label>
                                    <label aria-label="sitrah_total_amount" class="form-control"
                                        v-html="sitrah.total_amount" />
                                </div>
                            </div>
                            <!--5:land_floor-->
                            <div class="flex gap-2 justify-between">
                                <div class="flex flex-col w-50">
                                    <label for="land_floor_notes">{{ t('Land Floor') }}</label>
                                    <small aria-label="land_floor_notes">{{ t(land_floor.notes) }}</small>
                                </div>
                                <div class="w-20">
                                    <label for="land_floor_qty">{{ t('Calculator.Qty') }}</label>
                                    <input id="land_floor_qty" type="number" value="0" class="form-control"
                                        v-model="land_floor.qty" min="0" max="9999" @change="calculate" />
                                </div>
                                <div class="w-20">
                                    <label for="land_floor_space">{{ t('Space') }}</label>
                                    <input id="land_floor_space" type="number" value="0" class="form-control"
                                        v-model="land_floor.space" min="0" max="9999" @change="calculate" />
                                </div>
                                <div class="w-20">
                                    <!--Total land_floor-->
                                    <label for="land_floor_total_amount">{{ t('Total') }}</label>
                                    <label aria-label="land_floor_total_amount" class="form-control"
                                        v-html="land_floor.total_amount" />
                                </div>
                            </div>
                            <!--6:recur_floor-->
                            <div class="flex gap-2 justify-between">
                                <div class="flex flex-col w-50">
                                    <label for="recur_floor_notes">{{ t('Recur Floor') }}</label>
                                    <small aria-label="recur_floor_notes">{{ t(recur_floor.notes) }}</small>
                                </div>
                                <div class="w-20">
                                    <label for="recur_floor_qty">{{ t('Calculator.Qty') }}</label>
                                    <input id="recur_floor_qty" type="number" value="0" class="form-control"
                                        v-model="recur_floor.qty" min="0" max="9999" @change="calculate" />
                                </div>
                                <div class="w-20">
                                    <label for="recur_floor_space">{{ t('Space') }}</label>
                                    <input id="recur_floor_space" type="number" value="0" class="form-control"
                                        v-model="recur_floor.space" min="0" max="9999" @change="calculate" />
                                </div>
                                <div class="w-20">
                                    <!--Total recur_floor-->
                                    <label for="recur_floor_total_amount">{{ t('Total') }}</label>
                                    <label aria-label="recur_floor_total_amount" class="form-control"
                                        v-html="recur_floor.total_amount" />
                                </div>
                            </div>
                            <!--7:relative_floor-->
                            <div class="flex gap-2 justify-between">
                                <div class="flex flex-col w-50">
                                    <label for="relative_floor_notes">{{ t('Relative Floor') }}</label>
                                    <small aria-label="relative_floor_notes">{{ t(relative_floor.notes) }}</small>
                                </div>
                                <div class="w-20">
                                    <label for="relative_floor_qty">{{ t('Calculator.Qty') }}</label>
                                    <input id="relative_floor_qty" type="number" value="0" class="form-control"
                                        v-model="relative_floor.qty" min="0" max="9999" @change="calculate" />
                                </div>
                                <div class="w-20">
                                    <label for="relative_floor_space">{{ t('Space') }}</label>
                                    <input id="relative_floor_space" type="number" value="0" class="form-control"
                                        v-model="relative_floor.space" min="0" max="9999" @change="calculate" />
                                </div>
                                <div class="w-20">
                                    <!--Total relative_floor-->
                                    <label for="relative_floor_total_amount">{{ t('Total') }}</label>
                                    <label aria-label="relative_floor_total_amount" class="form-control"
                                        v-html="relative_floor.total_amount" />
                                </div>
                            </div>
                            <!--8:stair_box-->
                            <div class="flex gap-2 justify-between">
                                <div class="flex flex-col w-50">
                                    <label for="stair_box_notes">{{ t('Stair Box') }}</label>
                                    <small aria-label="stair_box_notes">{{ t(stair_box.notes) }}</small>
                                </div>
                                <div class="w-20">
                                    <label for="stair_box_qty">{{ t('Calculator.Qty') }}</label>
                                    <input id="stair_box_qty" type="number" value="0" class="form-control"
                                        v-model="stair_box.qty" min="0" max="9999" @change="calculate" />
                                </div>
                                <div class="w-20">
                                    <label for="stair_box_space">{{ t('Space') }}</label>
                                    <input id="stair_box_space" type="number" value="0" class="form-control"
                                        v-model="stair_box.space" min="0" max="9999" @change="calculate" />
                                </div>
                                <div class="w-20">
                                    <!--Total stair_box-->
                                    <label for="stair_box_total_amount">{{ t('Total') }}</label>
                                    <label aria-label="stair_box_total_amount" class="form-control"
                                        v-html="stair_box.total_amount" />
                                </div>
                            </div>
                        </div>
                        <div class="flex gap-2 justify-between align-items-end w-full">
                            <button class="theme-btn" @click="print">
                                {{ t('Print Estimation') }}
                            </button>
                            <div class="w-22 flex flex-col">
                                <label for="total_amount">{{ t('Grand Total') }}</label>
                                <label aria-label="total_amount" class="form-control w-100" id="totalEstimatedAmount"
                                    v-html="calculateTotal()" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3"></div>
    </div>
</template>


<style lang="scss" scoped>
.theme-btn {
    background-color: #825D3B;
}
</style>